// extracted by mini-css-extract-plugin
export default {"main-header":"Header_main-header__WI7q4","faIcon":"Header_faIcon__49rBL","homeIcon":"Header_homeIcon__Oh9I6"};